// @flow
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'
import ui from 'ui'

type Props = {
  disabled?: boolean,
  primaryAction: () => void,
  primaryActionText: string,
  primaryActionDataCy: string,
}

export default function FormsPageActionButton({
  disabled = false,
  primaryAction,
  primaryActionText,
  primaryActionDataCy,
}: Props): React.Node {
  const { canCreatePacketForm } = usePermissions()

  if (!canCreatePacketForm) return null

  return (
    <div className=" max-w-screen-xl mx-auto md:px-3 md:pl-0 form-dropdown">
      <div className="sm:flex sm:space-x-4">
        <ui.PrimaryButton
          className="mb-4"
          dataCy={primaryActionDataCy}
          disabled={disabled}
          onClick={primaryAction}
        >
          {primaryActionText}
        </ui.PrimaryButton>
      </div>
    </div>
  )
}
